/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Templates_Empty_Viewing_ProtocolInputs */

const cs_templates_empty_viewing_protocol = /** @type {(inputs: Templates_Empty_Viewing_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Žádné šablony protokolu z prohlídky.`)
};

const en_templates_empty_viewing_protocol = /** @type {(inputs: Templates_Empty_Viewing_ProtocolInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No viewing protocol templates yet.`)
};

/**
* | output |
* | --- |
* | "No viewing protocol templates yet." |
*
* @param {Templates_Empty_Viewing_ProtocolInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const templates_empty_viewing_protocol = /** @type {((inputs?: Templates_Empty_Viewing_ProtocolInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Templates_Empty_Viewing_ProtocolInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_templates_empty_viewing_protocol(inputs)
	return cs_templates_empty_viewing_protocol(inputs)
});